import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  grid: {
    padding: theme.spacing(0, 3.75),
    height: theme.spacing(7.5),
    display: 'flex',
    alignItems: 'center',
  },

  justifyCenter: {
    display: 'flex',
    justifyContent: 'center',
  },

  currentPlayer: {
    backgroundColor: theme.palette.modal.default,
  },

  notReadyPlayer: {
    backgroundColor: theme.palette.action.disabledBackground,
  },
}));
